var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoBankSber(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.3514 7.76953C36.2889 8.99788 37.0826 10.3324 37.7163 11.7462L19.7395 25.1762L12.2266 20.4033V14.6612L19.7395 19.4341L35.3514 7.76953Z",
    fill: "#21A038"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.55927 20.0001C4.55927 19.7424 4.56547 19.4865 4.57787 19.232L0.0247968 19.0059C0.00929965 19.3357 5.50217e-06 19.6687 5.50217e-06 20.0047C-0.0019317 22.6305 0.507688 25.2307 1.49964 27.6563C2.49159 30.0821 3.94634 32.2854 5.78045 34.1399L9.01005 30.8684C7.59823 29.4434 6.47822 27.7495 5.7144 25.8844C4.95058 24.0192 4.55802 22.0194 4.55927 20.0001Z",
    fill: "url(#paint0_linear_2207_1823)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7355 4.61945C19.9896 4.61945 20.2422 4.62887 20.4932 4.64143L20.7211 0.0255256C20.3947 0.00981986 20.0661 0.00196796 19.7355 0.00196796C17.1434 -0.00123562 14.5763 0.514497 12.1814 1.51955C9.78659 2.52461 7.61123 3.9992 5.78027 5.85864L9.00988 9.13171C10.4161 7.70041 12.0876 6.56492 13.9283 5.79055C15.769 5.01618 17.7425 4.61818 19.7355 4.61945Z",
    fill: "url(#paint1_linear_2207_1823)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7357 35.3798C19.4815 35.3798 19.2289 35.3798 18.9764 35.3594L18.7485 39.9737C19.076 39.9904 19.4051 39.9989 19.7357 39.9989C22.3267 40.0016 24.8926 39.4855 27.2861 38.4802C29.6797 37.4748 31.8536 36 33.6832 34.1406L30.4598 30.8691C29.0533 32.2997 27.382 33.4345 25.5417 34.2086C23.7014 34.9827 21.7282 35.3808 19.7357 35.3798Z",
    fill: "url(#paint2_linear_2207_1823)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2905 7.30319L32.1275 4.43689C28.6204 1.55876 24.2426 -0.00798939 19.7297 3.06379e-05V4.61908C22.7856 4.61524 25.7706 5.55117 28.2905 7.30319Z",
    fill: "url(#paint3_linear_2207_1823)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4699 20.0001C39.4723 18.7985 39.3686 17.5989 39.1599 16.416L34.9121 19.5886C34.9121 19.7253 34.9121 19.8619 34.9121 20.0001C34.9132 22.1491 34.4687 24.2743 33.6076 26.238C32.7463 28.2017 31.4874 29.9601 29.9127 31.3992L32.9766 34.831C35.0238 32.9579 36.6598 30.6698 37.7784 28.1149C38.8971 25.5599 39.4733 22.7952 39.4699 20.0001Z",
    fill: "#21A038"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7356 35.3811C17.6149 35.3819 15.5178 34.9312 13.5799 34.0585C11.6421 33.1857 9.90668 31.9101 8.48613 30.3145L5.10156 33.4179C6.94953 35.493 9.20724 37.1513 11.7283 38.2853C14.2493 39.4191 16.9773 40.0034 19.7356 40.0001V35.3811Z",
    fill: "url(#paint4_linear_2207_1823)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M9.55867 8.59967L6.49642 5.16797C4.44858 7.04068 2.81201 9.32871 1.69285 11.8837C0.573697 14.4386 -0.0030512 17.2034 1.21392e-05 19.9988H4.55928C4.55834 17.85 5.0029 15.7247 5.86412 13.761C6.72535 11.7973 7.98405 10.0389 9.55867 8.59967Z",
    fill: "url(#paint5_linear_2207_1823)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2207_1823",
    x1: 6.70253,
    y1: 33.5635,
    x2: 1.60155,
    y2: 19.0134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#F1E813"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#E6E418"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#C9DA26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#A2CC39"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2207_1823",
    x1: 7.08203,
    y1: 6.67533,
    x2: 19.9552,
    y2: 1.8347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#0FA7DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#0098F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#0290EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2207_1823",
    x1: 18.4479,
    y1: 37.2111,
    x2: 32.9749,
    y2: 33.9728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#A2CC39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#86C239"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#219F38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2207_1823",
    x1: 18.7814,
    y1: 1.54704,
    x2: 31.2138,
    y2: 5.3327,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#0290EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#0C89CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2207_1823",
    x1: 6.24525,
    y1: 32.8556,
    x2: 19.7902,
    y2: 37.8506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#F1E813"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#EAE616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#D8DF1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#BAD52D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#A2CC39"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2207_1823",
    x1: 1.6985,
    y1: 20.558,
    x2: 7.24536,
    y2: 6.32019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#A2CC39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#81C45E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#0FA7DF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBankSber);
export default ForwardRef;